/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useCallback } from 'react';
var defaultRectState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
export var useMeasure = () => {
  var [rect = defaultRectState, setRect] = useState(defaultRectState);

  if (typeof window === 'undefined' || !('ResizeObserver' in window)) {
    return [null, rect];
  }

  var [observer] = useState(() => new window.ResizeObserver(_ref => {
    var [entry] = _ref;
    return setRect(entry.contentRect);
  }));
  var ref = useCallback(node => {
    observer.disconnect();

    if (node) {
      observer.observe(node);
    }
  }, [observer]);
  return [ref, rect];
};
//# sourceMappingURL=useMeasure.js.map